import './style.less';

export default function($log, $scope, $stateParams) {
  'ngInject';

  const vm = this;

  vm.stateParams = $stateParams;

  $log.debug('Users Learning Activated Tracks');
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/learning/tracks/index.js